import * as Diff from 'diff';
import './CodeComparison.scss';
import { CodeDiffCard } from './CodeDiffCard';
import React from 'react';
import { Col, Row } from 'antd';

export interface CodeComparisonProps {
	newCode: string;
	oldCode: string;
}

export const CodeComparison: React.FC<CodeComparisonProps> = ({ newCode, oldCode }) => {
	const diff = Diff.diffWordsWithSpace(oldCode ?? '', newCode ?? '');

	return (
		<Row
			className='code-comparison'
			gutter={ 20 }
			justify='space-between'>
			<Col span={ 12 }>
				<CodeDiffCard
					diff={ diff }
					type='old' />
			</Col>
			<Col span={ 12 }>
				<CodeDiffCard
					diff={ diff }
					type='new' />
			</Col>
		</Row>
	);
};
